// import axiosInstance from '../axiosInstance';
import apiClient from "./axiosInstanceBuyer";

// export const fetchUsers = () => {
//   return axiosInstance.get('/users');
// };

export const createBuyer = async (buyerData) => {
  return await apiClient.post("/buyers", buyerData);
};

export const getAllBuyers = async () => {
  return await apiClient.get("/allBuyers");
};

export const getBuyerByUserId = async (id) => {
  return await apiClient.get(`/user/${id}`);
};

export const getBuyerById = async (id) => {
  return await apiClient.get(`/buyers/${id}`);
};

export const getInspectorById = async (id) => {
  return await apiClient.get(`/user/${id}`);
};
